import React, { JSXElementConstructor, useCallback, useMemo } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import { SimpleDialogProps } from "../../components/SimpleDialog";

export function useDialog<State extends object>({
  component: DialogComponent,
  initialState: initialState,
}: {
  component: JSXElementConstructor<SimpleDialogProps> & { state?: State };
  initialState?: Partial<State>;
}) {
  const [dialogState, setDialogState] = useState<State | undefined>(undefined);
  const isOpen = Boolean(dialogState);

  const handleCloseDialog = useCallback(() => {
    setDialogState(undefined);
  }, []);

  const handleOpenDialog = useCallback((state: State) => {
    setDialogState({ ...initialState, ...state });
  }, []);

  const dialogProps = useMemo(
    () =>
      ({
        state: dialogState,
        open: isOpen,
        onClose: handleCloseDialog,
      } as SimpleDialogProps & { state: State }),
    [dialogState, isOpen, handleCloseDialog]
  );

  return {
    handleCloseDialog,
    openDialog: handleOpenDialog,
    dialogProps,
    Dialog: DialogComponent,
  };
}
